import useResize from "components/Hooks/useResize";
import dynamic from "next/dynamic";
import { useContext, useEffect  } from "react";
import { DeviceEnum } from "models/enums";
import { VehicleContext } from "context/vehicleContext";

import { AppContext } from "context/appContext";

const LoadingFilter = dynamic(() => import("components/vehicles/SRP/LoadingFilter"));
const KbbIcoPlugin = dynamic(() => import("components/vehicles/VDP/KbbIcoPlugin"));

const DropdownFilter = dynamic(
    () => import("components/vehicles/SRP/Dropdown")
);
const SearchInput = dynamic(
    () => import("components/vehicles/SRP/SearchInput")
);
const HtmlComponent = dynamic(() => import("components/Html/Html"));
const FilterSlider = dynamic(
    () => import("components/FilterSlider/FilterSlider")
);

const AdvanceSearch = ({
    srpSettings,
    thirdParty,
    companyInfo,
    lockedSearchAtTop,
}: any) => {
    const { whichDevice } = useResize();
    const isMobileDevice = whichDevice === DeviceEnum.MOBILE;
    const {
        currentState,
        resetFiltersClearAll
    } = useContext(VehicleContext);

    // destructuring state
    const { isLoadingFilters, filtersHash } = currentState;

    const {openFilterInMobile} = useContext(AppContext);

    // const showFilterCreditScore = srpSettings.showFilterCreditScore;
    // const showFilterPayment = srpSettings.showFilterPayment;
    const showFilterVehiclePrice = srpSettings.showFilterVehiclePrice;
    const showFilterMileage = srpSettings.showFilterMileage;
    const showFilterYear = srpSettings.showFilterYear;
    const showFilterStyle = srpSettings.showFilterStyle;
    const showFilterMake = srpSettings.showFilterMake;
    const showFilterModel = srpSettings.showFilterModel;
    const showFilterTransmission = srpSettings.showFilterTransmission;
    const showFilterLocation = srpSettings.showFilterLocation;
    const showHtmlUnderFilters = srpSettings.showHtmlUnderFilters;
    const htmlUnderFilter = srpSettings.htmlUnderFilter;

    const useKBB = thirdParty.useKBB;
    const useKBBICO = thirdParty.useKBBICO;
    const showKBBICOInSRP = thirdParty.showKBBICOInSRP;
    const urlKBBICO = thirdParty.urlKBBICO;

    const showKBBICO = useKBB && useKBBICO && showKBBICOInSRP && urlKBBICO;

    const showSearchInFilter = false;

    // const haveic = false; // string.IsNullOrEmpty(Request.Params["ic"]) ? false : true;
    // const h = 0;
    // const comeForLease = false; //string.IsNullOrEmpty(Request.Params["ifl"]) ? false : (Request.Params["ifl"].ToString() == "ys" ? true : false);
    // const income = 2700; // string.IsNullOrEmpty(Request.Params["inc"]) ? 2700 : Convert.ToDecimal(Request.Params["inc"].ToString());
    // income = income == 0 ? 2700 : income;

    useEffect(() => {
        const searchBar = document.querySelector(
            ".ax-search-bar"
        ) as HTMLElement | null;
        const menuBar = document.querySelector(
            "#menu"
        ) as HTMLElement | null;

        function lockSearchAtTopWhenScroll(){
            if (!(isMobileDevice && lockedSearchAtTop)) return;
            if (window.scrollY >= 100) {
                searchBar?.classList.add("sticky");
                menuBar?.classList.add("hide");
            } else {
                searchBar?.classList.remove("sticky");
                menuBar?.classList.remove("hide");
            }
        }

        window.addEventListener("scroll", lockSearchAtTopWhenScroll);
      
        return () => {
            window.removeEventListener("scroll", lockSearchAtTopWhenScroll);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobileDevice, lockedSearchAtTop]);

    return (
        <>
            <div className="listing-sidebar">
                {isLoadingFilters && (
                    <div id="infinitegifsrpfilters">
                        <div>
                            <LoadingFilter />
                        </div>
                    </div>
                )}
                <>
                    <h5 className="text-center filters-title p-t-10">Select Filters</h5>
                    <button
                        className="ax-close-filter hidden-lg hidden-md"
                        title="close filters"
                        onClick={openFilterInMobile}
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                    <>
                        {showSearchInFilter && (
                            <div style={{ marginLeft: "5px" }}>
                                <SearchInput
                                    // setFilter={(filterName: string, value: []) =>
                                    //     setFilter(filterName, value)
                                    // } 
                                />
                            </div>
                        )}
                        {showFilterVehiclePrice && (
                            <FilterSlider
                                typeName="internetPrice"
                                label="Price"
                                show={showFilterVehiclePrice}
                                step={100}
                            />
                        )}
                        {showFilterMileage && (
                            <FilterSlider
                                typeName="miles"
                                label="Mileage"
                                show={showFilterMileage}
                                step={1000}
                            />
                        )}
                        {showFilterYear && (
                            <FilterSlider
                                typeName="year"
                                label="Year"
                                show={showFilterYear}
                                useCommas={false}
                                step={1}
                            />
                        )}
                        {showFilterStyle && (
                            <DropdownFilter
                                filterName="style"
                                label="Style"
                                show={showFilterStyle}
                                filtersHash={filtersHash}
                            />
                        )}
                        {showFilterMake && (
                            <DropdownFilter
                                filterName="make"
                                label="Make"
                                show={showFilterMake}
                                filtersHash={filtersHash}
                            />
                        )}
                        {showFilterModel && (
                            <DropdownFilter
                                filterName="model"
                                label="Model"
                                show={showFilterModel}
                                filtersHash={filtersHash}
                            />
                        )}
                        {showFilterTransmission && (
                            <DropdownFilter
                                filterName="transmission"
                                label="Transmission"
                                show={showFilterTransmission}
                                filtersHash={filtersHash}
                            />
                        )}
                        {showFilterLocation && (
                            <DropdownFilter
                                filterName="lotName"
                                label="Location"
                                show={showFilterLocation}
                                filtersHash={filtersHash}
                            />
                        )}
                    </>
                </>
            </div>

            <div className="col-lg-12 ax-inside-filter">
                {isMobileDevice && (
                    <>
                        <div className="col-lg-12 col-xs-6 text-center">
                            <button
                                className="btn btn-default width-100"
                                style={{ margin: "10px 0px" }}
                                onClick={resetFiltersClearAll}
                            >
                                <span className="fa fa-eraser"></span> Clear
                            </button>
                        </div>
                        <div className="hidden-lg hidden-md col-xs-6 text-center">
                            <button
                                id="searchcarsbyfilter"
                                className="btn button red width-100"
                                style={{ margin: "10px 0px" }}
                                onClick={openFilterInMobile}
                            >
                                <span className="fa fa-search"></span> Search
                            </button>
                        </div>
                    </>
                )}

                {!isMobileDevice && (
                    <div className="col-lg-12 text-center">
                        <button
                            className="btn btn-default"
                            style={{ margin: "10px 0px" }}
                            onClick={resetFiltersClearAll}
                        >
                            <span className="fa fa-eraser"></span> Clear Filters
                        </button>
                    </div>
                )}

                {showKBBICO && (
                    <>
                        <KbbIcoPlugin
                            urlKBBICO={urlKBBICO}
                            companyName={companyInfo.companyName}
                        />
                    </>
                )}

                {showHtmlUnderFilters && (
                    <>
                        <br />
                        <HtmlComponent htmlValue={htmlUnderFilter} />
                    </>
                )}
            </div>
        </>
    );
};

// const equal = (prevProps: any, nextProps: any) => {
//     return prevProps.currentUrl === nextProps.currentUrl;
// };

export default AdvanceSearch; // memo(AdvanceSearch, equal);
